// extracted by mini-css-extract-plugin
export default {"columnWith":"ISubmitterEntries_columnWith__kytfm","btnColumn":"ISubmitterEntries_btnColumn__jPH7d"};